import React from "react";

export const SectionTitle = ({
  eyebrow,
  title,
  subtitle,
  centered = false,
  invert = false,
  className = "",
}) => {
  const alignment = centered ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignment} gap-3 sm:gap-4 mb-8 sm:mb-10 lg:mb-14 ${className}`}>
      {eyebrow && (
        <span className="eyebrow" data-testid="section-eyebrow">
          {eyebrow}
        </span>
      )}
      <h2
        className={`relative text-2xl sm:text-3xl lg:text-[44px] font-bold tracking-tight pb-4 sm:pb-5 leading-tight ${
          invert ? "text-white" : "text-abayle-green"
        }`}
        data-testid="section-title"
      >
        {title}
        <span
          className={`absolute bottom-0 ${centered ? "left-1/2 -translate-x-1/2" : "left-0"} w-12 sm:w-16 h-[3px] bg-abayle-gold`}
        />
      </h2>
      {subtitle && (
        <p
          className={`max-w-3xl text-sm sm:text-base lg:text-lg leading-relaxed ${
            invert ? "text-white/85" : "text-abayle-charcoal/80"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
